module.exports = __webpack_public_path__ + "img/vital.47b96e66.png";